const EmailSentIcon = () => (
  <svg width="159" height="158" viewBox="0 0 159 158" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M67 29L141 23L98 56L60 62L67 29Z" fill="white" stroke="black" />
    <path
      d="M37.6166 17.7949L60.3538 42.3837L44.302 73.959L78.1485 67.8908L93.5535 105.08L159 19.2663L37.6166 17.7949ZM33.4543 71.0261L39.7545 65.8565L31.6225 68.429L30.7732 67.244L34.1455 63.9803L29.7462 65.7529C12.9241 72.2852 0.99514 88.5641 0.99514 107.648C0.989033 113.745 2.23182 119.779 4.64688 125.377C7.06195 130.976 10.5981 136.021 15.0374 140.2C11.1986 133.47 9.18509 125.853 9.19633 118.105C9.19633 99.2587 21.1303 82.4614 37.6116 75.855L39.7002 70.8187L34.7627 72.9764L33.3753 71.1002L33.4543 71.0261ZM62.1806 58.0652L72.7025 39.5002L134.574 25.0234L62.1806 58.0652Z"
      fill="#E78850"
    />
  </svg>
);

export default EmailSentIcon;
